import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebTempTermoExtratoDesligamento } from '../models/WebTempTermoExtratoDesligamento.model';
import { environment } from 'environments/environment';
import { ListaIdPessoa } from '../models/listaIdPessoa.model';

@Injectable({
  providedIn: 'root'
})
export class EnviarEmailInstitutosLegaisService {
  private strAction = 'api/WebTempTermoExtratoDesligamento';

  constructor(private http: HttpClient) {

  }

//http://localhost:40320/api/EnvioEmailIntitutosLegais/EnviarEmailInstitutosLegais
  public enviarEmailInstitutosLegais(listaIdPessoa:number[]): Observable<WebTempTermoExtratoDesligamento> {
    return this.http.post<WebTempTermoExtratoDesligamento>(`${environment.TrustCRMApiHost}api/EnvioEmailIntitutosLegais/EnviarEmailInstitutosLegais`,listaIdPessoa);
  }
//TrustCRMApiHost

}
